import {DATASET_MIXPANEL} from './constants';

export function convertRollupClause(clause) {
  if (clause.behavior.dataset && clause.behavior.dataset !== DATASET_MIXPANEL) {
    const datasetFilter = {
      dataset: DATASET_MIXPANEL,
      defaultType: `string`,
      determiner: `all`,
      filterOperator: `equals`,
      filterType: `string`,
      filterValue: [clause.behavior.dataset],
      resourceType: `events`,
      value: `$dataset`,
    };

    return {
      ...clause,
      behavior: {
        ...clause.behavior,
        dataset: DATASET_MIXPANEL,
        filters: [...(clause.behavior.filter || []), datasetFilter],
      },
    };
  }

  return clause;
}

export function cleanSection(clauses) {
  return clauses.map((clause) => ({
    ...clause,
    dataset: DATASET_MIXPANEL,
  }));
}

export function convertRollupBookmark(bookmark) {
  if (bookmark.sections && bookmark.sections.show) {
    const convertedClauses = bookmark.sections.show.map((clause) => convertRollupClause(clause));
    return {
      ...bookmark,
      sections: {
        ...bookmark.sections,
        group: cleanSection(bookmark.sections.group || []),
        time: cleanSection(bookmark.sections.time || []),
        show: convertedClauses,
      },
    };
  }

  return bookmark;
}
